<template>
  <div>
    <styled-subheading>
      {{ $t('digitalizationProjectInformations.informations') }}
    </styled-subheading>
    <project-form
      display-cancel-button
      :mode="ProjectFormMode.EDIT"
      :project-data="transformedProjectData"
      :project-type="ProjectType.DIGITALIZATION_PROJECT"
      @submit="handleSubmit"
    ></project-form>
    <digitalization-project-docu-responsibles
      :digitalization-project-id="projectId"
    ></digitalization-project-docu-responsibles>
  </div>
</template>

<script lang="ts" setup>
  import ProjectForm from '@/components/ProjectForm/ProjectForm.vue';
  import DigitalizationProjectDocuResponsibles from '@/components/DigitalizationProjectDocuResponsibles/DigitalizationProjectDocuResponsibles.vue';
  import { IDigitalizationProjectDetailsDto, ProjectType } from 'types';
  import {
    ProjectFormFields,
    ProjectFormMode,
  } from '../ProjectForm/ProjectForm.types';
  import { computed } from 'vue';
  import { ProjectDataService } from '@/services';
  import { useI18n } from 'vue-i18n';
  import { useToast } from '@/composables/useToast';

  const emit = defineEmits<{
    (e: 'project-data-upated'): void;
  }>();
  const props = defineProps<{
    projectId: string;
    projectData: IDigitalizationProjectDetailsDto;
  }>();

  const { t } = useI18n();
  const { createSuccessToast, createErrorToast } = useToast();

  const transformedProjectData = computed(() =>
    ProjectDataService.transformDigitalizationProjectDataToFormFields(
      props.projectData,
    ),
  );

  async function handleSubmit(projectForm: ProjectFormFields) {
    try {
      await ProjectDataService.updateDigitalizationProject(
        props.projectId,
        projectForm,
      );
      createSuccessToast(t('projectForm.projectDataUpdated'));
    } catch (err) {
      createErrorToast(t('projectForm.errors.errorUpdatingProject'));
    }
    emit('project-data-upated');
  }
</script>
